import ApiService from 'src/shared/utils/base-api/api-service';
import {ResponseDto} from 'src/shared/common-dtos/response-dto';
import {DeatilsRoleDto} from './dto/details-role-dto';
import {ParamsDto} from 'src/shared/common-dtos/params-dto';
import {DataListDto} from 'src/shared/common-dtos/data-list-dto';
import {UpdateRoleDto} from './dto/update-role-dto';

class RolesManagementService extends ApiService {
  constructor() {
    super({
      baseURL: '/Role',
    });
  }
  public getAllRoles(
    input?: ParamsDto,
  ): Promise<ResponseDto<DataListDto<DeatilsRoleDto>>> {
    return this.get('/GetAll', {
      params: input,
    });
  }

  public getRoleDetails(roleId: string): Promise<ResponseDto<DeatilsRoleDto>> {
    return this.get(`/GetDetails/${roleId}`);
  }

  public updateRole(role: UpdateRoleDto): Promise<ResponseDto<DeatilsRoleDto>> {
    return this.post('/EditRolePermissions', role);
  }

  public deleteRole(roleId: string): Promise<ResponseDto<DeatilsRoleDto>> {
    return this.delete(`/Delete/${roleId}`);
  }
  
  public getMyRoles(): Promise<ResponseDto<DeatilsRoleDto>> {
    return this.get('/GetMyRole');
  }
}

export const rolesManagementService = new RolesManagementService();
